import { render, staticRenderFns } from "./bottomCenter.vue?vue&type=template&id=52528452&scoped=true&"
import script from "./bottomCenter.vue?vue&type=script&lang=js&"
export * from "./bottomCenter.vue?vue&type=script&lang=js&"
import style0 from "./bottomCenter.vue?vue&type=style&index=0&id=52528452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52528452",
  null
  
)

export default component.exports